import React  from 'react';

const BaggageIcon = () => {
  return <span className="spec-img">
      <svg id="baggage" xmlns="http://www.w3.org/2000/svg" width="27.018" height="27.018" viewBox="0 0 27.018 27.018">
          <g id="Group_135" data-name="Group 135">
              <g id="Group_133" data-name="Group 133" transform="translate(0 0)">
                  <path id="Path_156" data-name="Path 156" d="M28.516,10h-4V6a1,1,0,0,0-1-1H13.506a1,1,0,0,0-1,1v4h-4a3.507,3.507,0,0,0-3.5,3.5V28.517a3.506,3.506,0,0,0,3.5,3.5H28.516a3.506,3.506,0,0,0,3.5-3.5V13.506A3.506,3.506,0,0,0,28.516,10ZM14.507,7h8v3h-8Zm15.51,21.515a1.5,1.5,0,0,1-1.5,1.5H8.5a1.5,1.5,0,0,1-1.5-1.5v-7.58a50.958,50.958,0,0,0,5.5.956v1.62a1,1,0,0,0,1,1H23.513a1,1,0,0,0,1-1V21.9a51.115,51.115,0,0,0,5.5-.949Zm-15.51-6v-3h8v3Zm10.007-2.626V18.509a1,1,0,0,0-1-1H13.506a1,1,0,0,0-1,1v1.369a49.1,49.1,0,0,1-5.5-1V13.506A1.5,1.5,0,0,1,8.5,12H28.515a1.5,1.5,0,0,1,1.5,1.5V18.9h0A49.229,49.229,0,0,1,24.514,19.886Z" transform="translate(-5 -5)" fill="#0081ca"/>
              </g>
          </g>
      </svg>
  </span>
}

export default BaggageIcon;
